<template>
  <el-scrollbar>
    <div class="page" ref="pageRef" @scroll.passive="handleScroll">
      <div
        class="h3-title flex-row flex-main-axis-between"
        style="margin-top: 0; margin-bottom: 0"
      >
        <span>SUP报单数据</span>
        <span></span>
      </div>
      <div class="shadow-box">
        <div class="page-main_box" style="height: auto">
          <div class="search-box" style="padding-top: 6px">
            <el-row :gutter="12">
              <el-col :span="4">
                <div class="search-item">
                  <div class="label">订单编号：</div>
                  <el-input
                    type="textarea"
                    :rows="1"
                    v-model="form.thirdOrderSn"
                    @blur="goSearch"
                    @clear="goSearch"
                    clearable
                    placeholder="多个编号使用换行"
                  ></el-input>
                </div>
              </el-col>
              <!--订单状态 -->
              <el-col :span="4">
                <div class="search-item">
                  <div class="label">订单状态：</div>
                  <el-select
                    clearable
                    style="width: 100%"
                    v-model="form.orderStatus"
                    @change="goSearch"
                    placeholder="选择状态"
                  >
                    <el-option :value="''" label="全部"></el-option>
                    <el-option
                      v-for="item in orderStatusList"
                      :key="item.id"
                      :value="item.tagCode"
                      :label="item.tagLabel"
                    ></el-option>
                  </el-select>
                </div>
              </el-col>
              <el-col :span="4">
                <div class="search-item">
                  <div class="label">报单状态：</div>
                  <el-select
                    clearable
                    multiple
                    collapse-tags
                    style="width: 100%; height: 32px;"
                    class="fixed-multi-select"
                    v-model="form.reportStatusList"
                    @change="handleReportStatusChange"
                    placeholder="选择状态"
                  >
                    <!-- 0-查询中 1-已跟单 2-已丢单 3-复核中 -->
                    <el-option :value="''" label="全部"></el-option>
                    <el-option :value="0" label="查询中"></el-option>
                    <el-option :value="1" label="已跟单"></el-option>
                    <el-option :value="2" label="已丢单"></el-option>
                    <el-option :value="3" label="复核中"></el-option>
                  </el-select>
                </div>
              </el-col>
              <el-col :span="4">
                <div class="search-item">
                  <div class="label">报单入口：</div>
                  <el-select
                    v-model="form.reportSource"
                    clearable
                    placeholder="请选择"
                  >
                    <el-option label="H5" value="H5"></el-option>
                    <el-option label="WEB" value="WEB"></el-option>
                  </el-select>
                </div>
              </el-col>
              <el-col :span="4">
                <div class="search-item">
                  <div class="label">报单时间：</div>
                  <el-date-picker
                    v-model="form.reportDate"
                    style="flex: 1"
                    type="daterange"
                    value-format="yyyy-MM-dd"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    :clearable="roleType == 1"
                    :picker-options="reportDateOptions"
                    @change="goSearch"
                  >
                  </el-date-picker>
                </div>
              </el-col>
              <el-col :span="4">
                <div class="search-item">
                  <!-- <div class="label">报单ID：</div>
                  <el-input
                    v-model="form.calculationFormId"
                    @blur="goSearch"
                    @clear="goSearch"
                    clearable
                    placeholder="请输入报单ID"
                  ></el-input> -->
                  <div class="label">产品编号：</div>
                  <el-input
                    v-model="form.productId"
                    @blur="goSearch"
                    @clear="goSearch"
                    clearable
                    placeholder="请输入产品编号"
                  ></el-input>
                </div>
              </el-col>
              <el-col :span="4">
                <div class="search-item">
                  <div class="label">商品名称：</div>
                  <el-input
                    v-model="form.productName"
                    @blur="goSearch"
                    @clear="goSearch"
                    clearable
                    placeholder="请输入商品名称"
                  ></el-input>
                </div>
              </el-col>
              <!-- <el-col :span="4">
              <div class="search-item">
                <div class="label">付款时间：</div>
                <el-date-picker
                  v-model="form.orderPayTime"
                  type="daterange"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  style="flex: 1;"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  @change="goSearch">
                </el-date-picker>
              </div>
            </el-col> -->

              <!-- 1 超管 -->
              <template v-if="roleType == 1">
                <el-col :span="4">
                  <div class="search-item">
                    <div class="label">一级账号：</div>
                    <el-select
                      clearable
                      filterable
                      style="width: 100%"
                      v-model="form.parentQdAccountId"
                      @change="oneQdChange"
                      placeholder="请选择"
                    >
                      <el-option
                        v-for="item in groupList1"
                        :key="item.accountId"
                        :value="item.accountId"
                        :label="item.nickName"
                      ></el-option>
                    </el-select>
                  </div>
                </el-col>
                <el-col :span="4">
                  <div class="search-item">
                    <div class="label">二级账号：</div>
                    <el-select
                      clearable
                      filterable
                      style="width: 100%"
                      @change="twoQdChange"
                      :disabled="!form.parentQdAccountId"
                      v-model="form.qdAccountId"
                      placeholder="请选择"
                    >
                      <el-option
                        v-for="item in groupList2"
                        :key="item.accountId"
                        :value="item.accountId"
                        :label="item.nickName"
                      ></el-option>
                    </el-select>
                  </div>
                </el-col>
              </template>

              <!-- 一级 -->
              <template v-if="roleType == 3">
                <el-col :span="4">
                  <div class="search-item">
                    <div class="label">二级账号：</div>
                    <el-select
                      clearable
                      style="width: 100%"
                      filterable
                      @change="twoQdChange"
                      v-model="form.qdAccountId"
                      placeholder="请选择"
                    >
                      <el-option
                        v-for="item in groupList2"
                        :key="item.accountId"
                        :value="item.accountId"
                        :label="item.nickName"
                      ></el-option>
                    </el-select>
                  </div>
                </el-col>
              </template>
              <!-- 下游账号 -->
              <el-col :span="4" v-if="!isDownAccount">
                <div class="search-item">
                  <div class="label">归属下游：</div>
                  <!-- 2-二级渠道不禁
                :disabled="!(form.parentQdAccountId || form.qdAccountId) && roleType != 2" -->
                  <el-select
                    clearable
                    filterable
                    style="width: 100%"
                    v-model="form.downAccountId"
                    @change="goSearch"
                    placeholder="请选择"
                  >
                    <el-option
                      v-for="item in downAccountList"
                      :key="item.accountId"
                      :value="item.accountId"
                      :label="item.nickName"
                    ></el-option>
                  </el-select>
                </div>
              </el-col>

              <el-button type="primary" @click="goSearch">查 询</el-button>
            </el-row>
          </div>

          <!-- 超管 / 一级 -->
          <div class="summary-line" style="padding-bottom: 10px">
            <div class="fl">
              <el-button type="primary" @click="showAddReportHandler"
                >新增报单</el-button
              >
              <el-button
                type="primary"
                :disabled="pageInfo.total === 0"
                @click="getAllList"
                icon="el-icon-download"
                :loading="downloadLoading"
                >导出</el-button
              >
              <el-button type="primary" @click="showImportSettlementStatusDialog = true">结算状态批量维护</el-button>
            </div>
          </div>

          <div class="code-list-content" ref="tableContainer">
            <el-table
              class="y-table"
              border
              stripe
              v-if="roleType"
              :key="tableKey"
              ref="multipleTable"
              style="width: calc(100vw - 256px)"
              v-bind="heightAttr"
              :data="tableData"
              @selection-change="handleSelectionChange"
              v-loading="isLoading"
            >
              <el-table-column fixed type="index" width="45"> </el-table-column>
              <el-table-column prop="thirdOrderSn" label="订单编号" width="70">
              </el-table-column>
              <el-table-column
                prop="orderStatusName"
                label="订单状态"
                width="120"
              ></el-table-column>
              <el-table-column
                prop="productMainImage"
                label="商品主图"
                width="96"
              >
                <template slot-scope="{ row }">
                  <div>
                    <el-image
                      v-if="row.productMainImage"
                      shape="square"
                      :preview-src-list="[row.productMainImage]"
                      style="width: 80px; height: 80px"
                      fit="cover"
                      :src="row.productMainImage"
                    ></el-image>
                    <span v-else>--</span>
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                prop="商品基础信息"
                min-width="240px"
                label="商品基础信息"
              >
                <template slot-scope="{ row }">
                  <div>
                    <div class="flex flex-center">
                      <img
                        :src="row.platformLogo"
                        :alt="row.platformName"
                        style="
                          width: 20px;
                          height: 20px;
                          vertical-align: middle;
                          margin-right: 4px;
                        "
                      />
                      <span class="text-title">产品编号：</span
                      >{{ row.productId || "--" }}
                    </div>
                    <div>
                      {{ row.categoryName }} {{ row.brandName }}
                      {{ row.productName }}
                    </div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                prop="orderAmount"
                min-width="100px"
                label="订单金额(元)"
              />
              <el-table-column
                prop="orderNumber"
                min-width="100px"
                label="订单件数"
              />
              <el-table-column min-width="120px" label="佣金计算方式"
                v-if="!isXY"
              >
                <template slot-scope="{ row }">
                  <div v-if="row.promotionCalcMethod === 'fixed'">
                    <div class="text-title">固定佣金</div>
                    <div class="text-value">
                      ¥ {{ row.pdPromotionAmount || 0 }}/件
                    </div>
                  </div>
                  <div v-else>
                    <div class="text-title">佣金比例</div>
                    <div class="text-value">{{ row.promotionRate || 0 }}%</div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                v-if="!isXY"
                prop="promotionAmount"
                min-width="160px"
                label="订单结算佣金(元)"
              />
              <el-table-column
                prop="reportStatus"
                min-width="100px"
                label="报单状态"
              >
                <template slot-scope="{ row }">
                  <div>
                    <el-tag v-if="row.reportStatus === 1" type="primary"
                      >已跟单</el-tag
                    >
                    <el-tag v-else-if="row.reportStatus === 2" type="danger"
                      >已丢单</el-tag
                    >
                    <el-tag v-else-if="row.reportStatus === 3" type="success"
                      >复核中</el-tag
                    >
                    <el-tag v-else-if="row.reportStatus === 0" type="info"
                      >查询中</el-tag
                    >
                    <span v-else>--</span>
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="reportSource" label="报单入口" width="96">
                <template slot-scope="{ row }">
                  <div class="table-cell">
                    <div class="table-line">{{ row.reportSource || "--" }}</div>
                    <div class="table-line title">报单用户</div>
                    <el-tooltip
                      :content="row.reportAccountName"
                      :disabled="
                        row.reportAccountName &&
                        row.reportAccountName.length < 6
                      "
                    >
                      <div class="table-line">
                        {{ row.reportAccountName || "--" }}
                      </div>
                    </el-tooltip>
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="reportTime" label="报单时间" width="100">
                <template slot-scope="{ row }">
                  <div>{{ row.reportTime | filterDateHMS }}</div>
                </template>
              </el-table-column>
              <el-table-column
                prop="parentQdAccountName"
                label="归属渠道"
                v-if="!isXY"
                width="96"
              >
                <template slot-scope="{ row }">
                  <div class="table-cell">
                    <div :class="['table-line']">
                      {{ row.parentQdAccountName || "--" }}
                    </div>
                    <div class="table-line title">归属二级渠道</div>
                    <el-tooltip
                      :content="row.qdAccountName"
                      :disabled="
                        row.qdAccountName && row.qdAccountName.length < 6
                      "
                    >
                      <div :class="['table-line']">
                        {{ row.qdAccountName || "--" }}
                      </div>
                    </el-tooltip>
                    <div class="table-line title">归属下游</div>
                    <el-tooltip
                      :content="row.downAccountName"
                      :disabled="
                        row.downAccountName && row.downAccountName.length < 6
                      "
                    >
                      <div :class="['table-line blue-bg']">
                        {{ row.downAccountName || "--" }}
                      </div>
                    </el-tooltip>
                  </div>
                </template>
              </el-table-column>
              <!-- 渠道结算状态 -->
              <el-table-column prop="channelSettlementStatus" min-width="100px" label="渠道结算状态" />
              <el-table-column prop="qdRemark" min-width="100px" label="备注" />
              <el-table-column width="120" label="更新备注">
                <template slot-scope="{ row }">
                  <div>
                    <el-input
                      type="textarea"
                      :row="2"
                      v-model="row.remarkInput"
                      placeholder="请填写您的备注"
                    />
                    <el-button
                      type="primary"
                      style="width: 100%; margin-top: 3px"
                      v-if="row.remarkInput"
                      size="small"
                      @click="submitRemarkHandler(row)"
                      >提交</el-button
                    >
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                prop="bpsRemark"
                min-width="120px"
                label="审单回执"
              />
              <el-table-column min-width="160px" label="订单截图">
                <template slot-scope="{ row }">
                  <div class="flex-row flex-wrap" v-if="row.orderScreenshot">
                    <el-image
                      v-for="(item, index) in row.orderScreenshot.split(',')"
                      :key="index"
                      :src="item"
                      :preview-src-list="row.orderScreenshot.split(',')"
                      style="width: 40px; height: 40px; margin: 0px 4px 4px 0"
                    ></el-image>
                  </div>
                </template>
              </el-table-column>
              <!-- <el-table-column fixed="right" label="操作" width="100">
                <template slot-scope="{ row }">
                  <el-button
                    v-if="row.canModify"
                    type="text"
                    @click="handleModify(row)"
                    >修改</el-button
                  >
                </template>
              </el-table-column> -->
            </el-table>
            <div class="bd--pag flex-row flex-main-axis-between">
              <el-pagination
                v-if="pageInfo.total > 0"
                class="d-ib"
                background
                layout="total, sizes, prev, pager, next, jumper"
                :total="pageInfo.total"
                :page-sizes="pageInfo.sizes"
                :page-size="pageInfo.size"
                :current-page="pageInfo.current"
                @current-change="(pageInfo.current = arguments[0]), getList()"
                @size-change="(pageInfo.size = arguments[0]), getList()"
              >
              </el-pagination>
            </div>
          </div>
        </div>

        <!-- 新增 -->
        <AddReportDialog
          v-if="showAddReportDialog"
          v-model="showAddReportDialog"
          :roleType="roleType"
          @check-result="checkResultCb"
          @close="showAddReportDialog = false; goSearch()"
          @on-success="showAddResultDialogHandler"
          @refresh-list="goSearch"
        />

        <!-- 检查结果弹框 -->
        <CheckResultDialog
          v-if="showCheckResultDialog"
          v-model="showCheckResultDialog"
          :rst="checkResult"
          @close="showCheckResultDialog = false"
        />

        <AddResultDialog
          v-if="showAddResultDialog"
          v-model="showAddResultDialog"
          @close="
            showAddResultDialog = false;
            importResult = {};
            goSearch()
          "
          :importResult="importResult"
          :roleType="roleType"
          @on-success="addReportSuccessHandler"
        />

        <!-- 修改报单 -->
        <EditReportDialog
          v-if="showEditReportDialog"
          v-model="showEditReportDialog"
          :row="editRow"
          @close="showEditReportDialog = false"
          @on-success="editReportSuccessHandler"
        />

        <!-- 结算状态批量维护 -->
        <ImportSettlementStatusDialog
          v-if="showImportSettlementStatusDialog"
          v-model="showImportSettlementStatusDialog"
          @close="showImportSettlementStatusDialog = false"
          @on-success="showImportSettlementStatusDialog = false; goSearch()"
        />
      </div>
    </div>
  </el-scrollbar>
</template>
<script>
import AddReportDialog from "@/page/component/sections/order/sup-add-report-dialog.vue";
import EditReportDialog from "@/page/component/sections/order/sup-edit-report-dialog.vue";
import AddResultDialog from "@/page/component/sections/order/sup-add-result-dialog.vue";
import CheckResultDialog from "@/page/component/sections/order/check-result-dialog.vue";
import ImportExportDialog from "@/page/component/sections/order/import-export-dialog.vue";
import ImportSettlementStatusDialog from "@/page/component/sections/order/import-settlement-status-dialog.vue";
import { numberFormat } from "@/utils/util";
import {
  getAccountRoleType,
  queryOrderReportPageWeb,
  removeOrderReportWeb,
} from "@/service/apis/order";
import { getTagList } from "@/service/apis/supShopTag";
import moment from "moment";
import { douyinM2SPageList } from "@/service/apis/group";
import { getBdDownStreamAccountList } from "@/service/apis/streamAccount";
import { throttle } from "lodash";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import {
  getFields,
  typeMap,
  getOrderStatus,
  moneyFormatFn,
  computedPromotionRate,
  rebateInfoTypes,
  toFixed1,
  amountFixed1,
} from "./sup-fields";
import { getUserId } from "@/utils/getUser";
import NP from "number-precision";
const dayjs = require("dayjs");
// 订单状态
// const orderStatusList = [
//   {
//     label: '预售未付尾款',
//     value: 'PRESALE_UNPAID'
//   },
//   {
//     label: '预售已付尾款',
//     value: 'PRESALE_PAID'
//   },
//   {
//     label: '订单已支付',
//     value: 'PAID'
//   },
//   {
//     label: '订单已确认收货',
//     value: 'CONFIRMED'
//   },
//   {
//     label: '订单有退款',
//     value: 'REFUNDED'
//   },
//   {
//     label: '订单已失效',
//     value: 'CANCELLED'
//   }
// ]

export default {
  components: {
    AddReportDialog,
    EditReportDialog,
    ImportExportDialog,
    AddResultDialog,
    CheckResultDialog,
    ImportSettlementStatusDialog,
  },
  computed: {
    isDownAccount() {
      return this.roleType == 4;
    },
    fields() {
      return getFields(this.roleType);
    },
    // 下游账号
    isXY() {
      return this.roleType == 4
    },
  },
  data() {
    return {
      orderStatusList: [],
      reportDateOptions: this.createPickerOptions(),
      downAccountList: [],
      heightAttr: {},
      tableKey: 0,
      downloadLoading: false,
      allList: [],
      columnShow: false,
      form: {
        thirdOrderSn: "",
        calculationFormId: "",
        productName: "",
        id: "",
        reportDate: [],
        orderPayTime: [],
        orderReceiveTime: [],
        reportStatusList: [], // 修改为数组形式支持多选
        incomeStatus: "",
        parentQdAccountId: "", // 一级账号,
        qdAccountId: "", // 二级账号
      },
      curTab: "",
      pageInfo: {
        current: 1,
        size: 10,
        sizes: [10, 20, 30, 50, 100],
        pages: 0,
        total: 0,
      },
      // 1-超管 2-二级渠道 3-一级渠道
      roleType: null,
      isLoading: false,
      tableData: [],
      editRow: null,
      multipleSelection: [],
      showAddReportDialog: false,
      groupList1: [],
      groupList2: [],
      importResult: {},
      showAddResultDialog: false,
      tableContainerTop: null,
      showImportSettlementStatusDialog: false,
      checkResult: null,
      showCheckResultDialog: false,
      showEditReportDialog: false,
    };
  },
  filters: {
    filterRate(rate) {
      if (rate !== null && rate !== undefined) {
        return NP.times(rate, 100) + "%";
      }
      return "--";
    },
    filterBTYJRate(row) {
      // {{ (row.subsidyPromotionRate !== null && row.subsidyPromotionRate !== undefined) ? ((row.subsidyPromotionRate || 0) * 100).toFixed(2) + '%' : '--' }}
      if (
        row.subsidyPromotionRate !== null &&
        row.subsidyPromotionRate !== undefined
      ) {
        return toFixed1((row.subsidyPromotionRate || 0) * 100) + "%";
      }
      return "--";
    },
    filterThirdType(type) {
      return typeMap[type] || "--";
    },
    filterDate(date) {
      if (date) {
        // return dayjs(date).format('YYYY-MM-DD HH:mm:ss')
        return dayjs(date).format("YYYY-MM-DD");
      }
      return "--";
    },
    filterDateHMS(date) {
      if (date) {
        return dayjs(date).format("YYYY-MM-DD HH:mm:ss");
      }
      return "--";
    },
    filterRebateInfoType(type) {
      return rebateInfoTypes[type] || "--";
    },
    filterAmountYuan(amount) {
      if (amount !== null && amount !== undefined && amount !== "") {
        return numberFormat(amount, 2);
      }
      return "--";
    },
    filterNum(num) {
      if (num !== null && num !== undefined && num !== "") {
        return numberFormat(num, 0);
      }
      return "--";
    },
    filterAmount(amount) {
      return moneyFormatFn(amount) || "--";
    },
    filterAmountFixed1(amount) {
      return amountFixed1(moneyFormatFn(amount)) || "--";
    },
    filterTotalAmount(row) {
      let settleCommissionAmount = row.settleCommissionAmount;
      if (settleCommissionAmount !== null) {
        settleCommissionAmount = NP.divide(settleCommissionAmount, 100);
        let arr = (settleCommissionAmount + "").split(".");
        if (arr[1]) {
          settleCommissionAmount = arr[0] + "." + arr[1].substring(0, 1);
        }
        return settleCommissionAmount;
      }
      return "--";
      // const promotionAmount = row.promotionAmount
      // const subsidyAmount = row.subsidyAmount
      // let total = promotionAmount === null && subsidyAmount === null ? '--' : moneyFormatFn((promotionAmount || 0) + (subsidyAmount || 0))

      // let arr = (total + '').split('.')
      // if (arr[1]) {
      //   total = arr[0] + '.' + arr[1].substring(0, 1)
      // }

      // return total || '--'
    },
    filterDdzyj(row) {
      // 佣金 promotionAmount+补贴佣金 subsidyAmount
      return moneyFormatFn(
        (row.promotionAmount || 0) + (row.subsidyAmount || 0)
      );
    },
    filterRate(rate) {
      if (rate !== null && rate !== undefined) {
        return NP.times(rate, 100) + "%";
      }
      return "--";
    },
    filterPromotionRate(row) {
      return computedPromotionRate(row, 1) || "--";
    },
    filterTotalPromotionRate(row) {
      return row.settleCommissionRate !== null
        ? row.settleCommissionRate * 100 + "%"
        : "--"; // 直接去接口返回
      // 佣金比 + 补贴佣金比例
      // const PromotionRate = computedPromotionRateValue(row)
      // const subsidyPromotionRate = (row.subsidyPromotionRate !== null && row.subsidyPromotionRate !== undefined) ? (row.subsidyPromotionRate || 0) * 100 :  ''
      // if (subsidyPromotionRate === '' && PromotionRate === '') {
      //   return '--'
      // }
      // let total = NP.plus(PromotionRate || 0, subsidyPromotionRate || 0)
      // // 截一位小数点
      // total = toFixed1(total)

      // return total + '%'
    },
    filterIncomeStatus(status) {
      // 1是已返 0是未返
      return status == 1 ? "已返" : status == 0 ? "未返" : "--";
    },
    filterOrderStatus(status) {
      return getOrderStatus(status) || "--";
    },
  },
  async created() {
    this.getTagList();
    // 获取角色
    await this.getAccountRoleType();
  },
  mounted() {
    this.$nextTick(() => {
      // window.addEventListener('scroll', this.handleScroll);
      this.$refs.scrollContainer &&
        this.$refs.scrollContainer.addEventListener(
          "scroll",
          this.handleScroll,
          { passive: true }
        );
    });
  },
  beforeDestroy() {
    // 移除滚动事件监听器
    // window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    getTagList() {
      const tagType = "ORDER_STATUS";
      getTagList
        .call(this, {
          tagType,
        })
        .then((res) => {
          this.orderStatusList = [...(res || [])].filter(
            (item) => item.tagType === tagType
          );
        });
    },
    submitRemarkHandler(row) {
      if (!row.remarkInput) {
        this.$message.error("请输入备注");
        return false;
      }
      this.$http('post', `mall/supOrderReport/updateItemQdRemark?itemId=${row.itemId}&qdRemark=${row.remarkInput}`).then((res) => {
          if (res) {
            this.$message.success("提交备注成功");
            row.remarkInput = "";
            this.getList();
          }
        });
    },
    createPickerOptions() {
      const self = this;
      return {
        onPick: (date) => {
          // 当选择了一个日期时，记录该日期
          if (date.minDate && !date.maxDate) {
            self.tempSelectedDate = date.minDate;
          } else {
            self.tempSelectedDate = null;
          }
        },
        disabledDate: (time) => {
          // 如果没有已选择的日期，则不禁用
          if (!self.tempSelectedDate) {
            return false;
          }

          // 超管限制一个月，其他6个月
          const sixMonths =
            this.roleType === 1
              ? 30 * 24 * 60 * 60 * 1000
              : 180 * 24 * 60 * 60 * 1000;

          // 限制可选日期在已选日期的前后6个月内
          return (
            Math.abs(time.getTime() - self.tempSelectedDate.getTime()) >
            sixMonths
          );
        },
      };
    },
    getDownAccountList(parentAccountId) {
      this.downAccountList = [];
      getBdDownStreamAccountList
        .call(this, {
          pageIndex: 1,
          pageSize: 1000,
          status: 1,
          parentAccountId,
        })
        .then((res) => {
          const { records } = res;
          this.downAccountList = [...(records || [])];
        });
    },
    checkResultCb(rst) {
      console.log("checkResult", rst);
      this.checkResult = rst;
      this.showAddReportDialog = false;
      this.showCheckResultDialog = true;
    },
    handleScroll: throttle(function (event) {
      const container = event.target || this.$refs.scrollContainer;
      if (!container) return;
      if (container.scrollTop >= 160) {
        this.$set(this.heightAttr, "height", "calc(100vh - 115px)");
      } else {
        this.heightAttr = {};
      }
      this.$nextTick(() => {
        this.$refs.multipleTable && this.$refs.multipleTable.doLayout();
      });
    }),
    computedDate(date) {
      if (date) {
        return dayjs(date).format("YYYY-MM-DD HH:mm:ss");
      }
      return "--";
    },
    filterReportStatus(status) {
      if (status == 1) {
        return '<span style="color: #1990FF;">已跟单</span>';
      } else if (status == 2) {
        return '<span style="color: #FF9F19;">已丢单</span>';
      } else if (status == 3) {
        return '<span style="color: #40D822;">复核中</span>';
      }

      return '<span style="color: #8F8F8F; font-size: 12px;">报单状态更新存在延迟，请稍等5min后刷新页面再试</span>';
    },
    computedRebatePromotionAmount(row) {
      // 佣金 promotionAmount+补贴佣金 promotionAmount
      return moneyFormatFn(
        (row.rebatePromotionAmount || 0) + (row.promotionAmount || 0)
      );
    },
    batchDelHandler() {
      const ids = this.multipleSelection.map((item) => item.thirdOrderSn);
      this.$confirm(
        `选中${this.multipleSelection.length}条数据，确定删除选中的数据吗？`,
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      ).then(() => {
        removeOrderReportWeb.call(this, ids).then(() => {
          this.$message({
            type: "success",
            message: "删除成功",
          });
          this.multipleSelection = [];
          this.goSearch();
        });
        // let list = []
        // ids.forEach(id => {
        //   list.push(delKlLiveRoomProduct.call(this, {
        //     liveRoomId: id
        //   }))
        // })
        // Promise.all(list).then(() => {
        //   this.$message({
        //     type: 'success',
        //     message: '删除成功'
        //   })
        //   this.multipleSelection = []
        //   this.goSearch()
        // })
      });
    },
    goSearch() {
      this.pageInfo.current = 1;
      this.getList();
    },
    oneQdChange(val) {
      this.form.qdAccountId = "";
      this.getAccountList(val);
      this.getDownAccountList(val);
      this.goSearch();
    },
    twoQdChange(val) {
      this.form.qdAccountId = val;
      this.getDownAccountList(val);
      this.goSearch();
    },
    handleReportStatusChange(value) {
      // 当选择多个非"全部"选项时，需要自动处理"全部"选项
      if (value && value.length > 1) {
        // 如果当前选中项包含空字符串（即"全部"选项），则移除它
        const allIndex = value.indexOf('');
        if (allIndex > -1) {
          // 过滤掉"全部"选项，只保留非"全部"选项
          const filteredValues = value.filter(item => item !== '');
          this.$nextTick(() => {
            this.form.reportStatusList = filteredValues;
          });
        }
      }
      
      // 触发搜索
      this.goSearch();
    },
    async getAllList() {
      this.downloadLoading = true;
      const pageSize = 500;
      const pages = Math.ceil(this.pageInfo.total / pageSize);
      const list = [];
      const params = this.getParams();
      if (pages >= 0) {
        for (let i = 0; i < pages; i++) {
          list.push(
            queryOrderReportPageWeb.call(this, {
              pageIndex: i + 1,
              pageSize: pageSize,
              ...params,
            })
          );
        }
      }
      const data = await Promise.all(list);
      if (data.length) {
        const allList = [];
        data.forEach((item) => {
          allList.push(...(item.records || []));
        });
        this.allList = allList;
        this.downloadExcel();
      }
    },
    // 导出
    downloadExcel() {
      const heads = [];
      const baseKeys = [];
      this.fields.forEach((item) => {
        if (
          typeof item.needExport === "undefined" ||
          (typeof item.needExport === "function" &&
            item.needExport(this.roleType))
        ) {
          let label = item.label;
          // 下游渠道 不显示开头‘下游’
          if (this.isDownAccount && label.indexOf("下游") === 0) {
            label = label.replace("下游", "");
          }
          heads.push(label);
          baseKeys.push(item.key);
        }
      });
      console.log(heads, "heads", baseKeys);

      const data = [[...heads]];

      this.allList.forEach((item) => {
        const values = [];
        this.fields.forEach((field) => {
          if (
            typeof field.needExport === "undefined" ||
            (typeof field.needExport === "function" &&
              field.needExport(this.roleType))
          ) {
            let val = item[field.key] || "";
            if (field.format) {
              val = field.format(item);
            }
            if (field.key === "productId" && val) {
              values.push("'" + val);
            } else {
              values.push(item.type === "number" ? { t: "s", v: val } : val);
            }
          }
        });

        data.push(values);
      });
      console.log(data[1], "data");

      this.downloadLoading = false;
      // 将数据转换为工作表
      const worksheet = XLSX.utils.aoa_to_sheet(data);

      // 创建工作簿并添加工作表
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

      // 生成Excel文件
      const excelBuffer = XLSX.write(workbook, {
        bookType: "xlsx",
        type: "array",
      });

      // 使用blob和FileReader创建一个URL然后下载
      const dataBlob = new Blob([excelBuffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
      });
      //
      saveAs(dataBlob, `报单列表 ${dayjs().format("YYYYMMDDHHmmss")}.xlsx`);
    },
    showAddReportHandler() {
      this.showAddReportDialog = true;
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    getAccountRoleType() {
      const accountId = getUserId();
      getAccountRoleType
        .call(this, {
          accountId, // getUserId()
        })
        .then((res) => {
          if (res) {
            this.roleType = res;
            console.log("this.roleType", this.roleType);
            if (this.roleType !== 1) {
              this.form.reportDate = [
                moment().subtract(30, "days").format("YYYY-MM-DD"),
                moment().format("YYYY-MM-DD"),
              ];
            }

            // 获取账号列表
            this.getAccountList();
            // 获取下游账号
            this.getDownAccountList(accountId);

            this.getList();
          }
        });
    },
    getAccountList(parentId) {
      // 超管 - 查看所有一级 1
      if (this.roleType == 1) {
        // one=1 就是 一渠道
        // 0就是二级
        douyinM2SPageList
          .call(this, {
            one: 1,
            current: 1,
            size: 1000,
          })
          .then((res) => {
            this.groupList1 = res.records || [];
          });
      }
      // 一级 查看二级列表
      if (this.roleType == 3 || parentId) {
        let opt = {
          one: 0, // 二级
          current: 1,
          size: 1000,
          parentId: getUserId(),
        };
        if (parentId) {
          opt.parentId = parentId;
        }
        douyinM2SPageList.call(this, opt).then((res) => {
          this.groupList2 = res.records || [];
        });
      }
    },
    getParams() {
      let form = JSON.parse(JSON.stringify(this.form));
      // 报单时间
      if (form.reportDate && form.reportDate.length) {
        form.reportDateBegin = moment(form.reportDate[0]).format("YYYY-MM-DD");
        form.reportDateEnd = moment(form.reportDate[1]).format("YYYY-MM-DD");
      }
      delete form.reportDate;
      // 支付时间
      if (form.orderPayTime && form.orderPayTime.length) {
        form.orderPayTimeBegin = form.orderPayTime[0];
        form.orderPayTimeEnd =
          moment(form.orderPayTime[1]).format("YYYY-MM-DD") + " 23:59:59";
      }
      delete form.orderPayTime;
      // 支付时间
      // if (form.orderReceiveTime && form.orderReceiveTime.length) {
      //   form.orderReceiveTimeBegin = form.orderReceiveTime[0]
      //   form.orderReceiveTimeEnd = moment(form.orderReceiveTime[1]).format('YYYY-MM-DD') + ' 23:59:59'
      // }
      // delete form.orderReceiveTime

      // 角色：1-超管 2-二级渠道 3-一级渠道
      // if (form.reportStatusList) {
      //   switch (this.roleType) {
      //     case 1:
      //       form.qdReportStatus = form.reportStatusList
      //       break
      //     case 2:
      //       form.clientReportStatus = form.reportStatusList
      //       break
      //     case 3:
      //       form.qdSubReportStatus = form.reportStatusList
      //       break
      //   }
      // }
      // delete form.reportStatusList

      // 佣金
      if (form.incomeStatus !== "") {
        switch (this.roleType) {
          // case 1:
          //   form.qdCommissionIncomeStatus = form.incomeStatus
          //   break
          case 2:
            form.qdSubCommissionIncomeStatus = form.incomeStatus;
            break;
          case 3:
            form.qdCommissionIncomeStatus = form.incomeStatus;
            break;
        }
      }
      delete form.incomeStatus;

      form.accountId = getUserId(); // 登录账号

      let rst = {};
      for (let key in form) {
        if (form[key] !== "" && form[key] !== null && form[key] !== undefined) {
          if(key === 'reportStatusList' && Array.isArray(form[key]) && form[key].length > 0) {
            // 对reportStatusList进行特殊处理，过滤掉空字符串，然后转换为逗号分隔的字符串
            const filteredValues = form[key].filter(item => item !== '');
            if(filteredValues.length > 0) {
              rst.reportStatusList = filteredValues
            }
          } else if(form[key] !== '') {
            rst[key] = form[key];
          }
        }
      }
      // 订单编号，多个
      if (form.thirdOrderSn) {
        rst.thirdOrderSnList = form.thirdOrderSn
          .split("\n")
          .map((item) => item.trim())
          .filter((item) => !!item);
        delete rst.thirdOrderSn;
      }

      return rst;
    },
    getList() {
      this.isLoading = true;
      this.tableData = [];
      this.pageInfo.total = 0;
      let params = this.getParams();

      queryOrderReportPageWeb
        .call(this, {
          ...params,
          pageIndex: this.pageInfo.current,
          pageSize: this.pageInfo.size,
        })
        .then((res) => {
          const { records, pages, total } = res;
          this.pageInfo.total = total || 0;
          this.pageInfo.pages = pages || 0;
          this.tableData = [...(records || [])].map((item) => {
            return {
              ...item,
              remarkInput: "",
            };
          });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    showAddResultDialogHandler(rst) {
      this.showAddReportDialog = false;
      this.importResult = rst;
      this.showAddResultDialog = true;
      this.goSearch()
    },
    handleModify(row) {
      this.editRow = row;
      this.showEditReportDialog = true;
    },
    editReportSuccessHandler() {
      this.showEditReportDialog = false;
      this.getList();
    },
    addReportSuccessHandler() {
      this.showAddResultDialog = false;
      this.getList();
    },
  },
};
</script>
<style scoped>
.search-box .flex-row {
  padding-bottom: 8px;
}
.search-box .flex-row:last-child {
  padding-bottom: 0;
}
.summary-line {
  height: auto;
  overflow: hidden;
  font-size: 14px;
  line-height: 28px;
  color: #666;
}
.table-cell {
  display: flex;
  flex-direction: column;
}
.table-cell .table-line {
  padding: 0 10px;
  box-sizing: border-box;
  height: 22px;
  line-height: 22px;
  white-space: nowrap; /* 强制文本不换行 */
  overflow: hidden; /* 隐藏溢出内容 */
  text-overflow: ellipsis; /* 溢出时显示省略号 */
  width: 100%;
  border-bottom: 1px solid #e9edf7;
}
.table-cell .table-line.title {
  color: #909399;
  font-weight: 500;
}
.table-cell .table-line:last-child {
  border-bottom: none;
}
.el-table.y-table td {
  padding: 0 !important;
}
.red-bg {
  color: #fff !important;
  background-color: #ff9b9b;
}
.blue-bg {
  color: #fff !important;
  background-color: #5eb9e5;
}
.bd--pag {
  background: #fff;
  position: sticky;
  bottom: 0;
  margin-top: 0;
  padding: 10px 0;
  z-index: 9;
}
.shadow-box {
  box-shadow: none;
  border-radius: none;
  padding: 0 12px;
}

.y-table.el-table ::v-deep .el-table__header-wrapper {
  position: sticky;
  z-index: 99;
  top: 0;
}

.text1 {
  font-weight: 500;
  font-size: 12px;
  color: #8f8f8f;
}
.status-text {
  color: #555;
  font-weight: 500;
  font-size: 14px;
}
.search-item {
  margin-right: 0;
  padding-bottom: 8px;
}
.fixed-multi-select {
  width: 100% !important;
  height: 32px !important;
}
.fixed-multi-select ::v-deep .el-select__tags {
  max-height: 28px;
  overflow: auto;
}
.page {
  height: calc(100vh - 62px);
  overflow: scroll;
}
::v-deep .el-table th {
  position: relative;
}
.th-cell {
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  padding: 4px 8px;
}
</style>
